
import { AddressFields } from '../../../../account-info/models/form-models';

export enum NewHireStep {
	PersonalInfo = 'PersonalInfo',
	HireDetails = 'HireDetails',
	PersonReviewInternal = 'PersonReviewInternal',
    PersonReviewExternal = 'PersonReviewExternal',
    EmploymentType = 'EmploymentType',
    ClergyType = 'ClergyType',
    EmploymentCompensationLay = 'EmploymentCompensationLay',
    EmploymentCompensationClergy = 'EmploymentCompensationClergy',
}

export enum NewHireActionTypes {
	CLEAR_NEW_HIRE_STATE = 'CLEAR_NEW_HIRE_STATE',
	SET_STEP = 'SET_STEP',
    UPDATE_FORM_VALUES = 'UPDATE_FORM_VALUES',
    SET_IS_REVIEW = 'SET_IS_REVIEW',
    SET_BISHOP_DETAILS = 'SET_BISHOP_DETAILS',
    CLEAR_BISHOP_DETAILS = 'CLEAR_BISHOP_DETAILS',
}

export const newHireAddressRequiredSchema: AddressFields = {
	country: false,
	address1: false,
	address2: false,
	address3: false,
	city: false,
	state: false,
	postalCode: false,
};

export const newHireAddressRequiredSchemaSimple: AddressFields = {
    country: true,
    address1: true,
    address2: false,
    address3: false,
    city: true,
    state: false,
    postalCode: false,
};

export const newHireAddressRequiredSchemaComplete: AddressFields = {
    country: true,
    address1: true,
    address2: false,
    address3: false,
    city: true,
    state: true,
    postalCode: true,
};

export interface Bishop {
    guid: string,
    first_name: string,
    middle_name: string,
    last_name: string,
}

export interface BishopDetails {
    client_number: string,
    name: string,
    bishop: Bishop[],
}

export function GetNewHireAddressRequiredSchema(
    isRequired: boolean,
    countryCode: string,
  ): AddressFields {
      if (isRequired) {
          return countryCode === 'MX' || countryCode === 'US' || countryCode === 'CA'
          ? newHireAddressRequiredSchemaComplete
          : newHireAddressRequiredSchemaSimple;
        }
      
      return newHireAddressRequiredSchema;
  } 